import * as React from "react";
import styles from "./ChatBubble.module.scss";
import RulerContext from "../../contexts/RulerContext";
import useTrackers from "../../hooks/useTrackers";

const ChatBubble: React.FC = () => {
  const ruler = React.useContext(RulerContext);
  const tracker = useTrackers();

  // Only show on mobile devices (sm or smaller screens)
  if (!ruler.smOrSmaller) {
    return <></>;
  }

  return (
    <a
      href={`sms://${process.env.REACT_APP_PHONE_NUMBER}`}
      className={styles.chatBubble}
      aria-label="Chat with us"
      onClick={() => {
        tracker.trackEvent(`${process.env.TRACK_OPEN_TEXT_NAME}`, `${process.env.TRACK_OPEN_TEXT_VALUE}`);
      }}
    >
      <div className={styles.chatIcon}></div>
    </a>
  );
};

export default ChatBubble;
